import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=ff86f5a0"
import script from "./Finances.vue?vue&type=script&lang=js"
export * from "./Finances.vue?vue&type=script&lang=js"
import style0 from "./Finances.vue?vue&type=style&index=0&id=ff86f5a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports